import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageTitle } from "@/pages/admin/AdminLayout";
import { EmailLog } from "@/components/admin/EmailLog";
import { EmailTemplates } from "@/components/admin/EmailTemplates";
import { ComposeEmail } from "@/components/admin/ComposeEmail";

export default function Emails() {
  const [tab, setTab] = useState("log");
  return (
    <div data-testid="admin-emails-page">
      <PageTitle title="Emails" sub="Sent log, automated email templates and one-off messages." />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="rounded-full mb-6">
          <TabsTrigger value="log" className="rounded-full" data-testid="emails-tab-log">Sent log</TabsTrigger>
          <TabsTrigger value="templates" className="rounded-full" data-testid="emails-tab-templates">Templates</TabsTrigger>
          <TabsTrigger value="compose" className="rounded-full" data-testid="emails-tab-compose">Compose</TabsTrigger>
        </TabsList>
        <TabsContent value="log"><EmailLog /></TabsContent>
        <TabsContent value="templates"><EmailTemplates /></TabsContent>
        <TabsContent value="compose"><ComposeEmail onSent={() => setTab("log")} /></TabsContent>
      </Tabs>
    </div>
  );
}
